<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="1000px"
    :append-to-body="true"
  >
    <el-form :model="params" :rules="paramsRules" label-position="top" ref="shop" v-loading="loading">
      <h6 class="title">
        {{ $t('stores::store::shop_info') }}
        <el-tooltip :content="shoplusInfo" class="item" effect="dark" placement="top-start">
          <span class="tips pointer">
            <i class="icon-a-01wenhao iconfont-el"></i>
            {{ $t('stores::store::how_bind') }}
          </span>
        </el-tooltip>
      </h6>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('stores::store::shop_name')" prop="name">
            <el-input v-model.trim="shopName" :disabled="$demo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('stores::store::platform')" prop="mallType">
            <el-select
              :disabled="isDetail"
              :placeholder="$t('system::common::input_holder')"
              :popper-append-to-body="false"
              v-model="params.mallType"
            >
              <el-option :value="1" label="Shoplus" v-if="isDetail"></el-option>
              <el-option :value="2" label="Shopify"></el-option>
              <el-option :value="3" label="Shoplazza"></el-option>
              <el-option :value="4" label="Shopline"></el-option>
              <el-option :value="5" label="Shopbase"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('stores::store::shop_domail')" prop="domain">
            <el-input :disabled="isDetail" v-model.trim="params.domain">
              <template slot="prepend">
                <div>https://</div>
              </template>
              <template slot="append" v-if="params.mallType !== 1">
                <span v-if="params.mallType === 2">.myshopify.com</span>
                <span v-if="params.mallType === 3">.myshoplaza.com</span>
                <span v-if="params.mallType === 4">.myshopline.cn</span>
                <span v-if="params.mallType === 5">.onshopbase.com</span>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('stores::store::ind_domail')" prop="independDomain">
            <el-input :disabled="$demo" v-model.trim="params.independDomain" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('stores::store::category')" prop="shopCategoryId">
            <el-select
              :placeholder="$t('system::common::input_holder')"
              :popper-append-to-body="false"
              :disabled="$demo"
              v-model="params.shopCategoryId"
            >
              <el-option
                :key="item.dictItemValue"
                :label="item.dictItemKey"
                :value="item.dictItemValue"
                v-for="item in typeOptions"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="status">
            <div slot="label" style="display: inline-block">
              {{ $t('stores::store::shop_status') }}
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content" style="width: 132px">{{ $t('stores::store::open_close') }}</div>
                <i class="icon-a-01wenhao iconfont-el"></i>
              </el-tooltip>
            </div>
            <el-radio-group :disabled="$demo" v-model="params.status">
              <el-radio :label="1">{{ $t('stores::store::shop_open') }}</el-radio>
              <el-radio :label="0">{{ $t('stores::store::shop_close') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="certification">
        <h6 class="title">
          {{ $t('stores::store::authentication') }}
          <el-tooltip effect="dark" placement="bottom">
            <div slot="content" style="width: 200px">{{ $t('stores::store::authentication_info') }}</div>
            <i class="icon-a-01wenhao iconfont-el"></i>
          </el-tooltip>
          <span @click="showGuiderDialog = true" class="title-tip">{{ $t('stores::store::guide') }}</span>
        </h6>
        <el-row :gutter="24">
          <el-col :span="12" v-if="params.mallType === 1 || params.mallType === 2">
            <el-form-item label="API Key" prop="appKey">
              <el-input
                :disabled="$demo"
                :placeholder="$t('stores::store::holder::shoplus_api_key')"
                v-if="params.mallType === 1"
                v-model.trim="params.appKey"
              />
              <el-input
                :placeholder="$t('stores::store::holder::shopify_api_key')"
                :disabled="$demo"
                v-if="params.mallType === 2"
                v-model.trim="params.appKey"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="params.mallType === 1 || params.mallType === 2">
            <el-form-item :label="$t('stores::store::api_password')" prop="appSecret">
              <el-input
                :placeholder="$t('stores::store::holder::shoplus_api_password')"
                v-if="params.mallType === 1"
                :disabled="$demo"
                v-model.trim="params.appSecret"
              />
              <el-input
                :placeholder="$t('stores::store::holder::shopify_api_password')"
                v-if="params.mallType === 2"
                :disabled="$demo"
                v-model.trim="params.appSecret"
              />
            </el-form-item>
          </el-col>
          <template v-if="params.mallType === 3">
            <el-col :span="12">
              <el-form-item label="API Token" prop="token">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::api_token')"
                  v-model="params.token"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="API UID" prop="appKey">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::api_uid')"
                  v-model="params.appKey"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="API Secret" prop="appSecret">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::api_secret')"
                  v-model="params.appSecret"
                />
              </el-form-item>
            </el-col>
          </template>
          <template v-if="params.mallType === 4">
            <el-col :span="12">
              <el-form-item label="Shopline Token" label-width="130px" prop="token">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::shopline_token')"
                  v-model="params.token"
                />
              </el-form-item>
            </el-col>
          </template>
          <template v-if="params.mallType === 5">
            <el-col :span="12">
              <el-form-item :label="$t('stores::store::label::shopbase_api_key')" prop="appKey">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::shopbase_api_key')"
                  v-model.trim="params.appKey"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('stores::store::label::shopbase_api_secret')" prop="appSecret">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::shopbase_api_secret')"
                  v-model.trim="params.appSecret"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('stores::store::label::shopbase_webhook')" prop="webhookSecret">
                <el-input
                  :disabled="$demo"
                  :placeholder="$t('stores::store::holder::shopbase_webhook')"
                  v-model.trim="params.webhookSecret"
                />
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12" v-if="params.mallType === 2">
            <el-form-item label="Webhook" prop="webhookSecret">
              <el-input
                :placeholder="$t('stores::store::holder::shopify_webhook')"
                :disabled="$demo"
                v-model.trim="params.webhookSecret"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span class="footer_class" slot="footer">
      <el-button @click="dialogVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button :loading="isLoding" @click="submitConfirm" type="primary" v-show="isDetail && !isNew">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
      <el-button :loading="isLoding" @click="saveSuccess" type="primary" v-show="!isDetail && isNew">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </span>
    <el-dialog
      :title="$t('stores::store::sync_tips')"
      :visible.sync="isSyncShow"
      append-to-body
      style="margin-top: 20vh"
      width="400px"
    >
      {{ $t('stores::store::sync_again') }}
      <span class="footer_class" slot="footer">
        <el-button @click="saveSuccess">{{ $t('stores::store::no_sync') }}</el-button>
        <el-button @click="saveAndAsync" type="primary">{{ $t('stores::store::save_sync') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('stores::store::guide')"
      :visible.sync="showGuiderDialog"
      append-to-body
      class="auth-guide"
      width="500px"
    >
      <el-collapse accordion v-model="collapseName">
        <el-collapse-item :title="$t('stores::store::shop_guide', { mallType: 'shopify' })" name="1">
          <authGuider :shop="stepList[2]"></authGuider>
        </el-collapse-item>
        <el-collapse-item :title="$t('stores::store::shop_guide', { mallType: 'shopplazza' })" name="2">
          <authGuider :shop="stepList[3]"></authGuider>
        </el-collapse-item>
        <el-collapse-item :title="$t('stores::store::shop_guide', { mallType: 'shopline' })" name="3">
          <authGuider :shop="stepList[4]"></authGuider>
        </el-collapse-item>
        <el-collapse-item :title="$t('stores::store::shop_guide', { mallType: 'shopbase' })" name="4">
          <authGuider :shop="stepList[5]"></authGuider>
        </el-collapse-item>
        <!-- <el-collapse-item title="Shoplus店铺授权指引" name="3">
          <authGuider :shop="stepList[1]"></authGuider>
        </el-collapse-item>-->
      </el-collapse>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { getShopList, addShop, operateCategory, getSync } from '@/server/shopList'
import authGuider from './auth-guider'
import { guidanceConfig } from '../../../utils/config'

const defaultParams = {
  name: '',
  domain: '',
  shopCategoryId: '',
  independDomain: '',
  status: 1,
  mallType: 1,
  appKey: '',
  appSecret: '',
  token: '',
  locationId: '',
  shopId: '',
  webhookSecret: '',
}
const validateSpace = (rule, value, callback) => {
  if (value.trim && !value.trim()) {
    callback(new Error(window.$t('stores::store::rule_empty')))
  } else if (String(value).indexOf(' ') !== -1) {
    callback(new Error(window.$t('stores::store::rule_space')))
  } else {
    callback()
  }
}
const validateName = (rule, value, callback) => {
  if (value.trim().length > 20 || value.indexOf(' ') !== -1) {
    callback(new Error(window.$t('stores::store::rule_shop_name')))
  } else {
    callback()
  }
}

const validDomain = type => {
  return (rule, value, callback) => {
    if (!value && type === 'shop') {
      callback(new Error(this.$t('stores::store::rule_domain')))
    } else if (/[^\w\.\-\/]/gi.test(value)) {
      callback(
        new Error(
          (type === 'independ' ? window.$t('stores::store::ind_domail') : window.$t('stores::store::shop_domail')) +
            window.$t('stores::store::rule_error')
        )
      )
    } else {
      callback()
    }
  }
}
const validKey = name => {
  return (rule, value, callback) => {
    if (!value) {
      callback(new Error(window.$t('stores::store::rule_empty')))
      // } else if (/[^\w\.\-\_\s]/gi.test(value)) {
    } else if (/[\u4e00-\u9fa5]/.test(value)) {
      // 只验证不能输入中文
      callback(new Error(`${name}${window.$t('stores::store::rule_error')}`))
    } else {
      callback()
    }
  }
}

export default {
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    authGuider,
  },
  computed: {
    dialogTitle() {
      if (this.isNew) {
        return this.$t('stores::store::bind_shop')
      } else if (this.isDetail) {
        return this.$t('stores::store::shop_detail')
      }
      return this.$t('stores::store::edit_shop')
    },
    shopName: {
      get: function () {
        return this.params.name
      },
      // setter
      set: function (newValue) {
        this.params.name = newValue.toString().slice(0, 10)
      },
    },
  },
  watch: {
    dialogVisible(bool) {
      if (bool) {
        this.stepList = guidanceConfig(window.$t)
      }
    },
  },
  data() {
    return {
      isLoding: false,
      isSyncShow: false,
      isDisable: false,
      dialogVisible: false,
      runType: '',
      runPlatform: 'Shoplus',
      params: this.$deepClone(defaultParams),
      paramsRules: {
        name: [
          { required: true, message: this.$t('stores::store::rule_input_name'), trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
        ],
        domain: [
          { required: true, message: this.$t('stores::store::rule_domain'), trigger: 'blur' },
          { validator: validDomain('shop'), trigger: 'blur' },
        ],
        status: [
          { required: true, message: this.$t('stores::store::rule_select_status'), trigger: 'blur' },
          { validator: validateSpace, trigger: 'change' },
        ],
        mallType: [
          { required: true, message: this.$t('stores::store::rule_input_platform'), trigger: 'blur' },
          { validator: validateSpace, trigger: 'blur' },
        ],
        shopCategoryId: [
          { required: true, message: this.$t('stores::store::rule_select_category'), trigger: 'blur' },
          { validator: validateSpace, trigger: 'change' },
        ],
        token: [
          { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validKey('API Token'), trigger: 'blur' },
        ],
        independDomain: [
          // { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validDomain('independ'), trigger: 'blur' },
        ],
        webhookSecret: [
          { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validKey('webhook'), trigger: 'blur' },
        ],
        locationId: [
          { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validateSpace, trigger: 'blur' },
        ],
      },
      // APIKey: '',
      // APIPassword: '',
      // LocationID: '',
      // Webhoot: '',
      labelWidth: '120px',
      typeOptions: [],
      loading: false,
      showGuiderDialog: false, // 指引页弹框
      isSync: false,
      collapseName: '',
      stepList: {},
      shoplusInfo: this.$t('stores::store::bind_info'),
      shopTypes: {
        1: { name: 'Shoplus', domain: '.shoplus.net' },
        2: { name: 'Shopify', domain: '.myshopify.com' },
        3: { name: 'Shopplazza', domain: '.myshoplaza.com' },
        4: { name: 'Shopline', domain: '.myshopline.com' },
        5: { name: 'shopbase', domain: '.onshopbase.com' },
      },
    }
  },
  mounted() {
    // 根据店铺类型修改报错内容
    this.paramsRules = {
      ...this.paramsRules,
      ...{
        appKey: [
          { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validKey(this.checkKeyName('key')), trigger: 'blur' },
        ],
        appSecret: [
          { required: true, message: this.$t('stores::store::rule_input_something'), trigger: 'blur' },
          { validator: validKey(this.checkKeyName('secret')), trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    checkKeyName(name) {
      const _this = this
      const key = {
        1: 'API Key',
        2: 'API Key',
        3: 'API UID',
      }
      const secret = {
        1: this.$t('stores::store::api_password'),
        2: this.$t('stores::store::api_password'),
        3: 'API Secret',
      }
      if (name === 'key') {
        return key[_this.params.mallType]
      } else {
        return secret[_this.params.mallType]
      }
    },
    saveAndAsync() {
      this.isSync = true
      this.saveSuccess()
    },
    async handleAsync() {
      this.isSyncShow = false
      this.dialogVisible = false
      // 更新同步信息
      const { data } = await getSync({ shopId: this.params.id })
      if (data.code === 0) {
        this.$emit('getSyncData')
      }
    },
    async getOperateCategoryData() {
      const { data } = await operateCategory()
      this.typeOptions = data.data
    },
    show(row) {
      this.dialogVisible = true
      if (row) {
        row.shopCategoryId = row.shopCategoryId.toString()
        this.params = Object.assign(this.params, row)
      } else {
        this.params = { ...this.$deepClone(defaultParams) }
      }
      this.getOperateCategoryData()
    },
    submitConfirm() {
      if (this.params.status === 1) {
        this.isSyncShow = true
      } else {
        this.isSync = false
        this.saveSuccess()
      }
    },
    async saveSuccess() {
      const str = this.shopTypes[this.params.mallType].domain
      this.isSyncShow = false
      this.$refs.shop.validate(async valid => {
        if (valid) {
          this.isLoding = true
          if (this.isNew) {
            this.params.shopId = null
          }
          this.params.shopCategoryId = String(this.params.shopCategoryId)
          const domains = []
          let domain
          if (this.isNew) {
            domain = this.params.domain + str
          } else {
            // 是否为shoplus： 1 如果不是shoplus则自动添加后缀
            if (this.params.mallType !== 1) {
              domain = this.params.domain + str
            } else {
              domain = this.params.domain
            }
          }
          if (domain) {
            let obj = { domain: domain, domainType: 1, id: 1 }
            domains.push(obj)
          }
          if (this.params.independDomain) {
            let obj = { domain: this.params.independDomain, domainType: 2, id: 2 }
            domains.push(obj)
          }
          this.params = { ...this.params, domains }

          let obj = {
            ...this.params,
            lang: 'en',
            domain: this.isNew ? this.params.domain + str : this.params.domain,
          }
          const { data } = await addShop(obj)

          if (data.code === this.$code) {
            await this.$store.dispatch('getBindData')
            let successMsg = ''
            if (this.isNew) {
              successMsg = this.params.status
                ? this.$t('stores::store::message_success_webhook')
                : this.$t('stores::store::message_success')
            } else {
              successMsg =
                this.isSync && this.params.status
                  ? this.$t('stores::store::message_edit_success_webhook')
                  : this.$t('stores::store::message_edit_success')
            }
            this.$message.success(successMsg)
            if (this.isSync && this.isDetail) {
              this.handleAsync()
            }
            this.$emit('editAndadd')
            this.dialogVisible = false
          }
          this.isLoding = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-select {
  width: 100%;
}
.title {
  font-size: 16px;
  margin-bottom: 20px;
}
.title-tip {
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  margin-left: 10px;
  color: #0560fd;
  font-size: 14px;
}
/deep/.el-dialog__footer {
  text-align: center;
}
.auth-guide {
  margin-top: -30px;
  /deep/ .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
}
.icon-a-01wenhao {
  font-size: 14px;
  color: #999;
}
.tips {
  font-size: 14px;
  font-weight: normal;
  color: #999;
}
</style>
